import React, { useCallback, useState, useMemo } from 'react';
import PropTypes from 'prop-types';

import { Input } from 'antd';
const AntTextArea = Input.TextArea;

import './styles.less';

export const TextArea = ( props ) => {

    const [ textValue, setTextValue ] = useState( props.value );

    const handleChange = useCallback( ( e ) => {
        const value = e.currentTarget.value;
        setTextValue( value );

        if ( props.onChange ) {
            props.onChange( value );
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ props.onChange ] );

    /**
     * The number of characters currently used in the entered text.
     * @type { number }
     */
    const charCount = useMemo( () => {
        return ( textValue ) ? textValue.length : 0;
    }, [ textValue ] );

    return (
        <div className="text-area-container">
            { ( props.header ) &&
                <div className="text-area-header-container text-area-label">
                    { props.header }
                </div>
            }
            <AntTextArea
                rows={ props.defaultRows }
                allowClear
                onChange={ handleChange }
                value={ props.value }
                disabled={ props.disabled }
            />
            { ( props.showCharacterCount ) &&
                <div className="text-area-character-count-container text-area-label">
                    { `${ charCount }${ ( props.maxCharacterCount !== undefined ) ? `/ ${ props.maxCharacterCount }` : '' }` }
                </div>
            }
        </div>
    );
};

TextArea.defaultProps = {
    header: undefined,
    showCharacterCount: true,
    maxCharacterCount: undefined,
    defaultRows: 4,
    onChange: undefined,
    value: undefined,
        
    // value: 0,
    // interactable: true,
    // blocked: false,
    // onSelect: undefined,
    
    // ...
};

TextArea.propTypes = {
    header: PropTypes.oneOfType( [ PropTypes.string, PropTypes.node ] ),
    showCharacterCount: PropTypes.bool,
    maxCharacterCount: PropTypes.number,
    defaultRows: PropTypes.number,
    onChange: PropTypes.func,
    value: PropTypes.string,

    // maxValue: PropTypes.number,
    // interactable: PropTypes.bool,
    // blocked: PropTypes.bool,
    // onSelect: PropTypes.func,
    // ...
};

